export default __webpack_public_path__ + "static/media/Aspen Technology.51a997a1.png";